import { Action, ActionCreator, ActionCreatorProps, createAction, NotAllowedCheck } from '@ngrx/store';

export interface NonUndoableTypedAction<T extends string> extends Action<T> {
  skipCreateUndo: true;
}

export function createNonUndoableAction<T extends string>(type: T): ActionCreator<T, () => NonUndoableTypedAction<T>>;
export function createNonUndoableAction<T extends string, P extends object>(
  type: T,
  config: ActionCreatorProps<P> & NotAllowedCheck<P>,
): ActionCreator<T, (props: P & NotAllowedCheck<P>) => P & NonUndoableTypedAction<T>>;
export function createNonUndoableAction<T extends string, P extends object>(
  type: T,
  config?: ActionCreatorProps<P> & NotAllowedCheck<P>,
): ActionCreator<T> {
  const creatorInteral = createAction(type, config as ActionCreatorProps<P> & NotAllowedCheck<P>);

  const creator = config
    ? (p: P & NotAllowedCheck<P>) => {
        const action = (creatorInteral as (props: P & NotAllowedCheck<P>) => P & Action<T>)(p);
        const actionWithProp = Object.defineProperty(action, 'skipCreateUndo', { value: true, writable: false });
        return actionWithProp;
      }
    : () => {
        const action = (creatorInteral as ActionCreator<T>)();
        const actionWithProp = Object.defineProperty(action, 'skipCreateUndo', { value: true, writable: false });
        return actionWithProp;
      };

  const nonUndoableActionCreator = Object.defineProperty(creator, 'type', {
    value: type,
    writable: false,
  });

  return nonUndoableActionCreator as ActionCreator<T>;
}
